import type { GetRecommendationsParams } from '@libs/common-types';

export const CWEA_ENDPOINTS = {
    account: {
        anonymousId: `account/anonymousId`,
        accounts: 'account/accounts',
    },
    cart: {
        fetchVetAuthImage: (cartId?: string, imageId?: string) =>
            `carts/${cartId}/items/vetAuth/${imageId}`,
        uploadVetAuthImage: (cartId?: string, itemId?: string) =>
            `carts/${cartId}/items/${itemId}/vetAuth`,
    },
    customerCare: {
        contactUs: `customerCare/contactUs`,
    },
    loyalty: {
        activateOffer: `loyalty/activateOffer`,
        getLoyaltyPoints: `loyalty/points`,
        getOffers: `loyalty/getLoyaltyOffers`,
        getMemberPoints: `loyalty/getMemberPoints`,
        getPointsHistory: `loyalty/pointsHistory`,
    },
    inventory: {
        getProductInventory: (sku: string) => `inventory/${sku}`,
        getProductInventoryPairs: `inventory`,
    },
    recommendations: {
        getProductRecommendations: ({
            productId,
            customerId,
            storeId,
            locale,
        }: GetRecommendationsParams) =>
            `recommendations/customer/${customerId}/product/${productId}/store/${storeId}/locale/${locale}`,
    },
    stores: {
        getStoreById: (storeId: string) => `stores/${storeId}`,
    },
    discounts: {
        getDiscountDetails: (key: string) => `discounts/${key}/details`,
    },
    orders: {
        getOrders: `orders`,
        getOrder: ({
            orderId,
            email,
            locale,
        }: {
            orderId: string;
            email?: string | null;
            locale: string;
        }) => {
            return email
                ? `orders/${orderId}?email=${encodeURIComponent(
                      email.trim().replaceAll(' ', '+')
                  )}&locale=${locale}`
                : `orders/${orderId}?locale=${locale}`;
        },
    },
    pets: {
        getPets: `pets`,
        addPet: `pets`,
        removePet: (petId: string) => `pets/${petId}`,
        editPet: (petId: string) => `pets/${petId}`,
        getPetsConfig: `pets/config`,
    },
    appointments: {
        getAppointments: `appointments`,
        updateAppointmentStatus: `appointments`,
        getPackages: `appointments/bundles`,
        getCustomerBookingEligibility: `appointments/eligibility`,
        getPetBookingEligibility: (petId: string) =>
            `appointments/eligibility/pets/${petId}`,
    },
    addresses: {
        getAddresses: 'addresses',
        addAddress: 'addresses',
        updateAddress: (addressId: number) =>
            `addresses?addressId=${addressId}`,
        removeAddress: (addressId: number) =>
            `addresses?addressId=${addressId}`,
    },
    product: {
        // For SSR - webStyleId or SKU
        getProductBase: (id: string) => `v2/product/${id}/base`,
    },
};

export const IDENTITY_ENDPOINTS = {
    consumeExchangeToken: 'v2/authentication/consumeExchangeToken',
    createExchangeToken: 'authentication/createExchangeToken',
};
